module.exports = __webpack_public_path__ + "img/plugin1.ba9fd859.png";